(() => {
  const FORM_SELECTOR = 'product-form[data-z-exotic-form]';
  const NOTICE_SELECTOR = '[data-z-exotic-notice]';
  const CONFIRM_SELECTOR = '[data-z-exotic-confirm]';
  const CANCEL_SELECTOR = '[data-z-exotic-cancel]';
  const FOCUSABLE_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const setLineItemProperty = (form, name, value) => {
    let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((candidate) => candidate.name === name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const initialiseForm = (productForm) => {
    if (productForm.dataset.zExoticReady === 'true') return;

    const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
    const notice = productForm.querySelector(NOTICE_SELECTOR);
    const confirmButton = notice?.querySelector(CONFIRM_SELECTOR);
    const cancelButtons = notice?.querySelectorAll(CANCEL_SELECTOR);
    if (!form || !notice || !confirmButton || !cancelButtons?.length) return;

    productForm.dataset.zExoticReady = 'true';
    let approvedSubmission = false;
    let triggerElement = null;

    const closeNotice = () => {
      notice.hidden = true;
      document.body.classList.remove('z-exotic-notice-open');
      triggerElement?.focus({ preventScroll: true });
      triggerElement = null;
    };

    const openNotice = () => {
      triggerElement = document.activeElement;
      notice.hidden = false;
      document.body.classList.add('z-exotic-notice-open');
      confirmButton.focus({ preventScroll: true });
    };

    form.addEventListener(
      'submit',
      (event) => {
        if (approvedSubmission) {
          approvedSubmission = false;
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        openNotice();
      },
      true
    );

    confirmButton.addEventListener('click', () => {
      const acknowledgement = productForm.dataset.zAckValue || 'Acknowledged – dispatch within up to 5 business days';
      const propertyLabel = productForm.dataset.zPropertyLabel || 'Exotic documentation notice';
      setLineItemProperty(form, `properties[${propertyLabel}]`, acknowledgement);
      setLineItemProperty(form, 'properties[_Exotic notice acknowledged at]', new Date().toISOString());
      approvedSubmission = true;
      closeNotice();
      form.requestSubmit();
    });

    cancelButtons.forEach((button) => button.addEventListener('click', closeNotice));

    notice.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeNotice();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(notice.querySelectorAll(FOCUSABLE_SELECTOR)).filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll(FORM_SELECTOR).forEach(initialiseForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
